<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"><span class="t5">Para Andy Eisenberg</span></p>
<p class="p0"><span class="t5">“Los amigos no se hacen, sino que se reconocen”.</span></p>
<p class="p5"><span class="t5">—Henrichs</span></p>
<p class="p1"> </p>
<p class="p1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?308e44b8